import { render, staticRenderFns } from "./page-wizard-financial.vue?vue&type=template&id=06dd7aed"
import script from "./page-wizard-financial.vue?vue&type=script&lang=js"
export * from "./page-wizard-financial.vue?vue&type=script&lang=js"
import style0 from "./page-wizard-financial.vue?vue&type=style&index=0&id=06dd7aed&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports